import parkpassAxiosInstance from "../parkpassAxiosConfig";

/**
 * Get admin dashboard overview
 * @returns {Promise} Dashboard overview data with all KPIs
 */
export const getAdminDashboardOverview = async () => {
  const response = await parkpassAxiosInstance.get("/v1/admin/dashboard/overview");
  return response.data;
};

/**
 * Format dashboard data for display
 * @param {Object} data - Raw dashboard data from API
 * @returns {Object} Formatted dashboard data
 */
export const formatDashboardData = (data) => {
  if (!data) return null;

  return {
    generatedAt: data.generated_at,
    users: {
      total: data.users?.total || 0,
    },
    wallets: {
      total: data.wallets?.total || 0,
      balanceTotal: data.wallets?.balance_total || 0,
      lockedTotal: data.wallets?.locked_total || 0,
      availableTotal: data.wallets?.available_total || 0,
    },
    transactions: {
      total: data.transactions?.total || 0,
      pending: data.transactions?.pending || 0,
      completed: data.transactions?.completed || 0,
      failed: data.transactions?.failed || 0,
      last24h: data.transactions?.last_24h || 0,
    },
    infractions: {
      total: data.infractions?.total || 0,
      unnotified: data.infractions?.unnotified || 0,
    },
    infractionDisputes: {
      total: data.infraction_disputes?.total || 0,
      pending: data.infraction_disputes?.pending || 0,
    },
    subscriptionRequests: {
      total: data.subscription_requests?.total || 0,
      last24h: data.subscription_requests?.last_24h || 0,
      byStatus: data.subscription_requests?.by_status || {},
    },
    parking: {
      parkingsTotal: data.parking?.parkings_total || 0,
      parkingsActive: data.parking?.parkings_active || 0,
      linesTotal: data.parking?.lines_total || 0,
    },
    vehicles: {
      total: data.vehicles?.total || 0,
      hidden: data.vehicles?.hidden || 0,
    },
    parkingTickets: {
      total: data.parking_tickets?.total || 0,
      pending: data.parking_tickets?.pending || 0,
      active: data.parking_tickets?.active || 0,
      expired: data.parking_tickets?.expired || 0,
      last24h: data.parking_tickets?.last_24h || 0,
    },
    notifications: {
      pushTokensTotal: data.notifications?.push_tokens_total || 0,
    },
    payments: {
      cmi: {
        total: data.payments?.cmi?.total || 0,
        pending: data.payments?.cmi?.pending || 0,
        completed: data.payments?.cmi?.completed || 0,
        failed: data.payments?.cmi?.failed || 0,
        amountCompleted: data.payments?.cmi?.amount_completed || 0,
      },
      fatourati: {
        total: data.payments?.fatourati?.total || 0,
        pending: data.payments?.fatourati?.pending || 0,
        paid: data.payments?.fatourati?.paid || 0,
        amountPaid: data.payments?.fatourati?.amount_paid || 0,
      },
    },
    systemWallets: data.system_wallets || {},
    financial: data.financial || {},
    revenue: {
      parkingDay: data.revenue?.parking_day || 0,
      parkingMonth: data.revenue?.parking_month || 0,
      fineDay: data.revenue?.fine_day || 0,
      fineMonth: data.revenue?.fine_month || 0,
      subscriptionDay: data.revenue?.subscription_day || 0,
      subscriptionMonth: data.revenue?.subscription_month || 0,
      totalDay: data.revenue?.total_day || 0,
      totalMonth: data.revenue?.total_month || 0,
    },
  };
};

/**
 * Reconcile infractions with agent-backend
 * @param {string} startDate - Start date (YYYY-MM-DD)
 * @param {string} endDate - End date (YYYY-MM-DD)
 * @returns {Promise} Reconciliation results
 */
export const reconcileInfractions = async (startDate, endDate) => {
  const response = await parkpassAxiosInstance.post("/v1/admin/dashboard/reconcile/infractions", null, {
    params: { start_date: startDate, end_date: endDate },
  });
  return response.data;
};
